import React, { useState, useRef, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { AlertTriangle } from "lucide-react";
import MasterResourceTable from "../MasterResourceManagement/MasterResourceTable/MasterResourceTable";
import IncidentTable from "./IncidentTable";
import EventTable from "./EventTable";


const IncidentManagementt = () => {
  const handle = useFullScreenHandle();
  const location = useLocation();
  // Pre-select (highlight) an incident when arriving from View Incident →
  // Quick Links → "Incident Closed".
  const [selectedIncidentId, setSelectedIncidentId] = useState(
    location.state?.highlightIncidentId ?? null
  );
  // Pre-select (highlight) an incident by its Incident ID (incident_seq_id)
  // when arriving from the SOP Instance List's Incident ID link.
  const [selectedIncidentSeqId, setSelectedIncidentSeqId] = useState(
    location.state?.highlightIncidentSeqId ?? null
  );

  // Keep the highlight in sync if we land here again with a new incident id
  // (component may stay mounted across navigations).
  useEffect(() => {
    if (location.state?.highlightIncidentId != null) {
      setSelectedIncidentId(location.state.highlightIncidentId);
    }
    if (location.state?.highlightIncidentSeqId != null) {
      setSelectedIncidentSeqId(location.state.highlightIncidentSeqId);
    }
  }, [location.state]);

  return (



    <>
    <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
    <div style={{margin:'8px', fontFamily: "'Poppins', 'Segoe UI', sans-serif"}}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "10px 14px",
          borderRadius: "10px",
          background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
          boxShadow: "0 2px 6px rgba(46,109,164,0.2)",
        }}
      >
        <div
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "8px",
            background: "rgba(255,255,255,0.16)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <AlertTriangle size={14} color="#fff" />
        </div>
        <div>
          <div style={{ fontSize: "14px", fontWeight: 800, color: "#fff", letterSpacing: ".2px" }}>
            Incident List
          </div>
          <div style={{ fontSize: "10.5px", color: "rgba(255,255,255,0.75)", marginTop: "1px" }}>
            Track and manage reported disaster incidents
          </div>
        </div>
      </div>
      <div style={{
        marginTop:'10px', backgroundColor: '#fff',
        borderRadius: '10px'
      }}>
        <IncidentTable
          onRowClick={(id) => setSelectedIncidentId(id)}
          selectedRowId={selectedIncidentId}
          selectedIncidentSeqId={selectedIncidentSeqId}
          initialSearch={location.state?.fromIncident || location.state?.highlightIncidentSeqId || ""}
        />


      </div>
      {/* <div style={{
        fontFamily: 'Arial, sans-serif', marginTop:'20px', backgroundColor: '#252b48',
        borderRadius: '10px'
      }}>
        <EventTable
          selectedIncidentId={selectedIncidentId} />
      </div> */}
      </div>
    </>





  );
};


export default IncidentManagementt;
